(() => {
  if (window.__oneAusbau) return;
  window.__oneAusbau = true;

  const ruhig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const mitte = (wurzel) => {
    const spur = wurzel.querySelector('slideshow-slides');
    const ich = wurzel.querySelector('[data-oww-ich]');
    if (!(spur instanceof HTMLElement) || !ich) return;
    if (wurzel.dataset.owwFest && String(spur.scrollLeft) !== wurzel.dataset.owwFest) return;
    const folie = ich.closest('slideshow-slide') || ich;
    const s = spur.getBoundingClientRect();
    const f = folie.getBoundingClientRect();
    if (!s.width) return;
    const delta = f.left + f.width / 2 - (s.left + s.width / 2);
    spur.scrollTo({ left: spur.scrollLeft + delta, behavior: 'instant' });
    wurzel.dataset.owwFest = String(spur.scrollLeft);
  };

  const HANDY = window.matchMedia('(max-width: 1023px)');
  const summen = () => {
    try {
      if (navigator.vibrate) navigator.vibrate(8);
    } catch (e) {
    }
  };
  const sichtbar = (k) => Array.from(k.querySelectorAll('.oww__variante')).find((v) => !v.hasAttribute('hidden')) || k;

  const regler = (wurzel) => {
    if (wurzel.dataset.owwRegler) return;
    const karten =  (Array.from(wurzel.querySelectorAll('.oww__karte[data-oww-n]')));
    const ns = Array.from(new Set(karten.map((k) => Number(k.dataset.owwN)).filter((n) => n > 0))).sort((a, b) => a - b);
    if (ns.length < 2) return;
    const reihe = wurzel.querySelector('.oww__reihe');
    if (!reihe || !reihe.parentNode) return;
    wurzel.dataset.owwRegler = '1';
    const t = wurzel.dataset;
    const ich = karten.find((k) => k.hasAttribute('data-oww-ich'));
    const ichN = ich ? Number(ich.dataset.owwN) : ns[0];
    const wege = (n) => karten.filter((k) => Number(k.dataset.owwN) === n);
    const wahl = {};
    ns.forEach((n) => {
      const o = wege(n);
      wahl[n] = o.find((k) => k === ich) || o.find((k) => k.dataset.owwTyp === 'aus') || o[0];
    });
    const L = ns.length - 1;
    let idx = Math.max(0, ns.indexOf(ichN));
    const pos = (i) => (L ? (i / L) * 100 : 50);
    const wort = (n) => ((n === 1 ? t.owwTEins : t.owwTMehr) || '').replace('#', '').trim();

    const box = document.createElement('div');
    box.className = 'oww__rbox';
    box.innerHTML =
      '<div class="oww__buehne"></div>' +
      `<div class="oww__regler" role="slider" tabindex="0" aria-label="${t.owwTRegler || ''}" aria-valuemin="${ns[0]}" aria-valuemax="${ns[L]}">` +
      '<span class="oww__r-spur"></span><span class="oww__r-fuell"></span>' +
      ns.map((n, i) => `<span class="oww__r-mk${n === ichN ? ' oww__r-mk--ich' : ''}" data-oww-i="${i}" style="left:${pos(i)}%"></span>`).join('') +
      '<span class="oww__r-griff"></span></div>' +
      '<div class="oww__r-stufen">' +
      ns.map((n, i) => `<button type="button" data-oww-i="${i}" style="left:${pos(i)}%"><b>${n}</b>${wort(n)}</button>`).join('') +
      '</div><div class="oww__r-reiter"></div>';
    reihe.parentNode.insertBefore(box, reihe);
    wurzel.classList.add('oww--regler');

    const buehne =  (box.querySelector('.oww__buehne'));
    const R =  (box.querySelector('.oww__regler'));
    const griff =  (R.querySelector('.oww__r-griff'));
    const fuell =  (R.querySelector('.oww__r-fuell'));
    const reiter =  (box.querySelector('.oww__r-reiter'));

    const ebene = (k) => {
      const e = document.createElement('div');
      e.className = 'oww__ebene';
      const b = sichtbar(k).querySelector('.oww__bild');
      if (b) e.appendChild(b.cloneNode(true));
      return e;
    };
    const ebenen = karten.map((k) => buehne.appendChild(ebene(k)));
    const neuesBild = (k) => {
      const i = karten.indexOf( (k));
      if (i < 0) return;
      const neu = ebene(k);
      buehne.replaceChild(neu, ebenen[i]);
      ebenen[i] = neu;
    };

    const setze = (w) => {
      const p = pos(w);
      griff.style.left = p + '%';
      fuell.style.width = p + '%';
      R.querySelectorAll('.oww__r-mk').forEach((m) =>
        m.classList.toggle('is-an', Number( (m).dataset.owwI) <= Math.round(w))
      );
      const a = Math.floor(w);
      const b = Math.min(L, a + 1);
      const f = w - a;
      const ka = wahl[ns[a]];
      const kb = wahl[ns[b]];
      ebenen.forEach((e, i) => {
        let o = 0;
        if (karten[i] === ka) o = a === b ? 1 : 1 - f;
        if (karten[i] === kb && a !== b) o = Math.max(o, f);
        e.style.opacity = String(o);
      });
    };
    const zeige = () => {
      const n = ns[idx];
      const an = wahl[n];
      karten.forEach((k) => (k.closest('slideshow-slide') || k).classList.toggle('is-oww-an', k === an));
      box.querySelectorAll('.oww__r-stufen button').forEach((b) =>
        b.classList.toggle('is-an', Number( (b).dataset.owwI) === idx)
      );
      const titel = sichtbar(an).querySelector('.oww__titel');
      R.setAttribute('aria-valuenow', String(n));
      R.setAttribute('aria-valuetext', `${n} ${wort(n)}${titel ? ', ' + (titel.textContent || '').trim() : ''}`);
      const o = wege(n);
      reiter.innerHTML = '';
      const andere = o.filter((k) => k.dataset.owwTyp !== 'teil');
      const hatTeil = andere.length < o.length;
      const hatUm = o.some((k) => k.dataset.owwTyp === 'um');
      const art = (k) => {
        const a = sichtbar(k).querySelector('.oww__art');
        return a ? (a.textContent || '').trim() : '';
      };
      const name = (k) => {
        const typ = k.dataset.owwTyp;
        if (typ === 'teil') return t.owwTTeil || '';
        if (typ === 'um') return t.owwTUm || '';
        if (hatUm && typ === 'ich') return t.owwTStd || '';
        if (hatTeil && andere.length === 1) return t.owwTEinzel || '';
        return art(k);
      };
      if (o.length < 2) {
        const zeile = document.createElement('p');
        zeile.className = 'oww__r-zeile oww__r-zeile--einzeln';
        zeile.textContent = art(an);
        reiter.appendChild(zeile);
        const breite = reiter.clientWidth;
        const stufe = box.querySelector('.oww__r-stufen .is-an');
        const ziel = stufe ? stufe.getBoundingClientRect().left + stufe.getBoundingClientRect().width / 2 - reiter.getBoundingClientRect().left : (breite * pos(idx)) / 100;
        zeile.style.insetInlineStart = Math.max(0, Math.min(breite - zeile.offsetWidth, ziel - zeile.offsetWidth / 2)) + 'px';
        return;
      }
      const namen = o.map(name);
      const zeile = document.createElement('div');
      zeile.className = 'oww__r-zeile';
      zeile.setAttribute('role', 'tablist');
      o.forEach((k, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'oww__r-tab' + (k === an ? ' is-an' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', String(k === an));
        b.textContent = namen.indexOf(namen[i]) !== i || namen.lastIndexOf(namen[i]) !== i ? `${namen[i]} ${i + 1}` : namen[i];
        b.addEventListener('click', () => {
          if (wahl[n] === k) return;
          wahl[n] = k;
          summen();
          setze(idx);
          zeige();
          const neu = reiter.querySelector('.is-an');
          if (neu instanceof HTMLElement) neu.focus();
        });
        zeile.appendChild(b);
      });
      reiter.appendChild(zeile);
      const breite = reiter.clientWidth;
      const stufe = box.querySelector('.oww__r-stufen .is-an');
        const ziel = stufe ? stufe.getBoundingClientRect().left + stufe.getBoundingClientRect().width / 2 - reiter.getBoundingClientRect().left : (breite * pos(idx)) / 100;
      const links = Math.max(0, Math.min(breite - zeile.offsetWidth, ziel - zeile.offsetWidth / 2));
      zeile.style.insetInlineStart = links + 'px';
      zeile.style.setProperty('--oww-spitze', ziel - links + 'px');
    };
    const geh = (i, weich = true) => {
      const neu = Math.max(0, Math.min(L, i));
      if (neu !== idx) summen();
      idx = neu;
      R.classList.toggle('is-ruhig', !weich);
      setze(idx);
      zeige();
    };
    const ausX = (x) => {
      const r = R.getBoundingClientRect();
      return Math.max(0, Math.min(L, ((x - r.left) / r.width) * L));
    };
    let zieht = false;
    R.addEventListener('pointerdown', (e) => {
      zieht = true;
      R.setPointerCapture(e.pointerId);
      R.classList.remove('is-ruhig');
      R.classList.add('is-zieht');
      setze(ausX(e.clientX));
    });
    R.addEventListener('pointermove', (e) => {
      if (!zieht) return;
      const v = ausX(e.clientX);
      setze(v);
      const n = Math.round(v);
      if (n !== idx) {
        idx = n;
        summen();
        zeige();
      }
    });
    const los = (e) => {
      if (!zieht) return;
      zieht = false;
      R.classList.remove('is-zieht');
      geh(Math.round(ausX(e.clientX)));
    };
    R.addEventListener('pointerup', los);
    R.addEventListener('pointercancel', los);
    R.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
        geh(idx + 1);
        e.preventDefault();
      }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
        geh(idx - 1);
        e.preventDefault();
      }
    });
    box.querySelector('.oww__r-stufen')?.addEventListener('click', (e) => {
      const b = e.target instanceof Element ? e.target.closest('[data-oww-i]') : null;
      if (b instanceof HTMLElement) geh(Number(b.dataset.owwI));
    });
    wurzel.addEventListener('click', (e) => {
      const s = e.target instanceof Element ? e.target.closest('.oww__schalter [data-oww-v]') : null;
      const k = s ? s.closest('.oww__karte') : null;
      if (!k) return;
      requestAnimationFrame(() => {
        neuesBild(k);
        setze(idx);
        zeige();
      });
    });
    geh(idx, false);
  };

  const alle = () =>
    document.querySelectorAll('[data-oww]').forEach((w) => {
      mitte( (w));
      if (HANDY.matches) regler( (w));
    });
  HANDY.addEventListener('change', () => {
    if (HANDY.matches) alle();
  });

  const start = () => {
    const bereit = window.customElements ? customElements.whenDefined('slideshow-component') : Promise.resolve();
    bereit.then(() => requestAnimationFrame(() => requestAnimationFrame(alle)));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('load', () => requestAnimationFrame(alle), { once: true });

  const liste = (text) =>
    (text || '')
      .split(',')
      .map((e) => e.trim())
      .filter(Boolean)
      .map((e) => {
        const [sku, n] = e.split(':');
        return { sku: (sku || '').toUpperCase(), n: parseInt(n, 10) || 1 };
      })
      .filter((t) => t.sku);

  document.addEventListener('click', (ev) => {
    const knopf = ev.target instanceof Element ? ev.target.closest('.oww__schalter [data-oww-v]') : null;
    if (!(knopf instanceof HTMLButtonElement) || knopf.classList.contains('is-an')) return;
    const karte = knopf.closest('.oww__karte');
    if (!karte) return;
    const wahl = knopf.dataset.owwV;
    let neu = null;
    karte.querySelectorAll('[data-oww-variante]').forEach((v) => {
      const an = v instanceof HTMLElement && v.dataset.owwVariante === wahl;
      v.toggleAttribute('hidden', !an);
      if (an) neu = v;
    });
    const fokus = neu ? neu.querySelector(`[data-oww-v="${wahl}"]`) : null;
    if (fokus instanceof HTMLElement) fokus.focus();
  });

  document.addEventListener('click', (ev) => {
    const ziel = ev.target instanceof Element ? ev.target.closest('a[data-oww-konfig]') : null;
    if (!(ziel instanceof HTMLAnchorElement)) return;
    const kaufzone = document.getElementById('kaufzone') || document.querySelector('.ost__wahl') || document.querySelector('[data-ost-liste]');
    ev.preventDefault();
    if (kaufzone) {
      kaufzone.scrollIntoView({ behavior: ruhig() ? 'auto' : 'smooth', block: 'start' });
      if (!kaufzone.hasAttribute('tabindex')) kaufzone.setAttribute('tabindex', '-1');
      kaufzone.focus({ preventScroll: true });
    }
    document.dispatchEvent(
      new CustomEvent('one:konfigurieren', {
        bubbles: true,
        detail: {
          teile: liste(ziel.dataset.oneTeile),
          empfohlen: liste(ziel.dataset.oneEmpfohlen),
          ziel: ziel.dataset.oneZiel || '',
          art: ziel.dataset.oneArt || 'ausbauen',
        },
      })
    );
  });
})();
